import { type EvidenceUploadMode, type ModelResults, useFeatureFlags } from 'api';

import { getAnalysisStatusAndRejectionReason } from '../../utils/getAnalysisStatusAndRejectionReason/getAnalysisStatusAndRejectionReason';

export const useAnalysisStatus = () => {
  const { getFlag } = useFeatureFlags();

  const getStatusAndRejectionReason = (mode: EvidenceUploadMode, modelResults: ModelResults) => {
    return getAnalysisStatusAndRejectionReason(mode, modelResults, getFlag('GRADE_SERVICE_ENABLED'));
  };

  return { getStatusAndRejectionReason };
};
